// src/utils/executeTransaction.ts
import {
  Transaction
} from "@solana/web3.js";
import { COMMON_TX_ERRORS, TransactionError as TransactionError2, handleSendTransaction } from "@mercurial-finance/optimist";

// src/utils/transactionHelpers.ts
import { TransactionError } from "@mercurial-finance/optimist";
import bs58 from "bs58";

// src/constants.ts
import { PublicKey } from "@solana/web3.js";

// src/idl/jupiter6.ts
var IDL_V6 = {
  version: "0.1.0",
  name: "jupiter",
  instructions: [
    {
      name: "route",
      docs: ["route_plan Topologically sorted trade DAG"],
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "userSourceTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "userDestinationTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "inAmount",
          type: "u64"
        },
        {
          name: "quotedOutAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "routeWithTokenLedger",
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "userSourceTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "userDestinationTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "tokenLedger",
          isMut: false,
          isSigner: false
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "quotedOutAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "sharedAccountsRoute",
      docs: ["Route by using program owned token accounts and open orders accounts."],
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "programAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "sourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programSourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programDestinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "token2022Program",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        },
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "inAmount",
          type: "u64"
        },
        {
          name: "quotedOutAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "sharedAccountsRouteWithTokenLedger",
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "programAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "sourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programSourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programDestinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "token2022Program",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "tokenLedger",
          isMut: false,
          isSigner: false
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        },
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "quotedOutAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "exactOutRoute",
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "userSourceTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "userDestinationTokenAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "sourceMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "token2022Program",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "outAmount",
          type: "u64"
        },
        {
          name: "quotedInAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "sharedAccountsExactOutRoute",
      docs: ["Route by using program owned token accounts and open orders accounts."],
      accounts: [
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "programAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "sourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programSourceTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "programDestinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "platformFeeAccount",
          isMut: true,
          isSigner: false,
          isOptional: true
        },
        {
          name: "token2022Program",
          isMut: false,
          isSigner: false,
          isOptional: true
        },
        {
          name: "eventAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "program",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        },
        {
          name: "routePlan",
          type: {
            vec: {
              defined: "RoutePlanStep"
            }
          }
        },
        {
          name: "outAmount",
          type: "u64"
        },
        {
          name: "quotedInAmount",
          type: "u64"
        },
        {
          name: "slippageBps",
          type: "u16"
        },
        {
          name: "platformFeeBps",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "setTokenLedger",
      accounts: [
        {
          name: "tokenLedger",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false
        }
      ],
      args: []
    },
    {
      name: "createOpenOrders",
      accounts: [
        {
          name: "openOrders",
          isMut: true,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "dexProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        },
        {
          name: "market",
          isMut: false,
          isSigner: false
        }
      ],
      args: []
    },
    {
      name: "createProgramOpenOrders",
      accounts: [
        {
          name: "openOrders",
          isMut: true,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "programAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "dexProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        },
        {
          name: "market",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        }
      ]
    },
    {
      name: "claim",
      accounts: [
        {
          name: "wallet",
          isMut: true,
          isSigner: false
        },
        {
          name: "programAuthority",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "claimToken",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "wallet",
          isMut: false,
          isSigner: false
        },
        {
          name: "programAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "programTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "associatedTokenTokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "associatedTokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "id",
          type: "u8"
        }
      ],
      returns: "u64"
    },
    {
      name: "createTokenLedger",
      accounts: [
        {
          name: "tokenLedger",
          isMut: true,
          isSigner: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: []
    }
  ],
  accounts: [
    {
      name: "tokenLedger",
      type: {
        kind: "struct",
        fields: [
          {
            name: "tokenAccount",
            type: "publicKey"
          },
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AmountWithSlippage",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "slippageBps",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "RoutePlanStep",
      type: {
        kind: "struct",
        fields: [
          {
            name: "swap",
            type: {
              defined: "Swap"
            }
          },
          {
            name: "percent",
            type: "u8"
          },
          {
            name: "inputIndex",
            type: "u8"
          },
          {
            name: "outputIndex",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Side",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Bid"
          },
          {
            name: "Ask"
          }
        ]
      }
    },
    {
      name: "Swap",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Saber"
          },
          {
            name: "SaberAddDecimalsDeposit"
          },
          {
            name: "SaberAddDecimalsWithdraw"
          },
          {
            name: "TokenSwap"
          },
          {
            name: "Sencha"
          },
          {
            name: "Step"
          },
          {
            name: "Cropper"
          },
          {
            name: "Raydium"
          },
          {
            name: "Crema",
            fields: [
              {
                name: "aToB",
                type: "bool"
              }
            ]
          },
          {
            name: "Lifinity"
          },
          {
            name: "Mercurial"
          },
          {
            name: "Cykura"
          },
          {
            name: "Serum",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "MarinadeDeposit"
          },
          {
            name: "MarinadeUnstake"
          },
          {
            name: "Aldrin",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "AldrinV2",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "Whirlpool",
            fields: [
              {
                name: "aToB",
                type: "bool"
              }
            ]
          },
          {
            name: "Invariant",
            fields: [
              {
                name: "xToY",
                type: "bool"
              }
            ]
          },
          {
            name: "Meteora"
          },
          {
            name: "GooseFX"
          },
          {
            name: "DeltaFi",
            fields: [
              {
                name: "stable",
                type: "bool"
              }
            ]
          },
          {
            name: "Balansol"
          },
          {
            name: "MarcoPolo",
            fields: [
              {
                name: "xToY",
                type: "bool"
              }
            ]
          },
          {
            name: "Dradex",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "LifinityV2"
          },
          {
            name: "RaydiumClmm"
          },
          {
            name: "Openbook",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "Phoenix",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "Symmetry",
            fields: [
              {
                name: "fromTokenId",
                type: "u64"
              },
              {
                name: "toTokenId",
                type: "u64"
              }
            ]
          },
          {
            name: "TokenSwapV2"
          },
          {
            name: "HeliumTreasuryManagementRedeemV0"
          },
          {
            name: "StakeDexStakeWrappedSol"
          },
          {
            name: "StakeDexSwapViaStake",
            fields: [
              {
                name: "bridgeStakeSeed",
                type: "u32"
              }
            ]
          },
          {
            name: "GooseFXV2"
          },
          {
            name: "Perps"
          },
          {
            name: "PerpsAddLiquidity"
          },
          {
            name: "PerpsRemoveLiquidity"
          },
          {
            name: "MeteoraDlmm"
          },
          {
            name: "OpenBookV2",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              }
            ]
          },
          {
            name: "RaydiumClmmV2"
          },
          {
            name: "StakeDexPrefundWithdrawStakeAndDepositStake",
            fields: [
              {
                name: "bridgeStakeSeed",
                type: "u32"
              }
            ]
          },
          {
            name: "Clone",
            fields: [
              {
                name: "poolIndex",
                type: "u8"
              },
              {
                name: "quantityIsInput",
                type: "bool"
              },
              {
                name: "quantityIsCollateral",
                type: "bool"
              }
            ]
          },
          {
            name: "SanctumS",
            fields: [
              {
                name: "srcLstValueCalcAccs",
                type: "u8"
              },
              {
                name: "dstLstValueCalcAccs",
                type: "u8"
              },
              {
                name: "srcLstIndex",
                type: "u32"
              },
              {
                name: "dstLstIndex",
                type: "u32"
              }
            ]
          },
          {
            name: "SanctumSAddLiquidity",
            fields: [
              {
                name: "lstValueCalcAccs",
                type: "u8"
              },
              {
                name: "lstIndex",
                type: "u32"
              }
            ]
          },
          {
            name: "SanctumSRemoveLiquidity",
            fields: [
              {
                name: "lstValueCalcAccs",
                type: "u8"
              },
              {
                name: "lstIndex",
                type: "u32"
              }
            ]
          },
          {
            name: "RaydiumCP"
          },
          {
            name: "WhirlpoolSwapV2",
            fields: [
              {
                name: "aToB",
                type: "bool"
              },
              {
                name: "remainingAccountsInfo",
                type: {
                  option: {
                    defined: "RemainingAccountsInfo"
                  }
                }
              }
            ]
          },
          {
            name: "OneIntro"
          }
        ]
      }
    },
    {
      name: "RemainingAccountsSlice",
      type: {
        kind: "struct",
        fields: [
          {
            name: "accountsType",
            type: {
              defined: "AccountsType"
            }
          },
          {
            name: "length",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "RemainingAccountsInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slices",
            type: {
              vec: {
                defined: "RemainingAccountsSlice"
              }
            }
          }
        ]
      }
    },
    {
      name: "AccountsType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TransferHookA"
          },
          {
            name: "TransferHookB"
          }
        ]
      }
    }
  ],
  events: [
    {
      name: "SwapEvent",
      fields: [
        {
          name: "amm",
          type: "publicKey",
          index: false
        },
        {
          name: "inputMint",
          type: "publicKey",
          index: false
        },
        {
          name: "inputAmount",
          type: "u64",
          index: false
        },
        {
          name: "outputMint",
          type: "publicKey",
          index: false
        },
        {
          name: "outputAmount",
          type: "u64",
          index: false
        }
      ]
    },
    {
      name: "FeeEvent",
      fields: [
        {
          name: "account",
          type: "publicKey",
          index: false
        },
        {
          name: "mint",
          type: "publicKey",
          index: false
        },
        {
          name: "amount",
          type: "u64",
          index: false
        }
      ]
    }
  ],
  errors: [
    {
      code: 6e3,
      name: "EmptyRoute",
      msg: "Empty route"
    },
    {
      code: 6001,
      name: "SlippageToleranceExceeded",
      msg: "Slippage tolerance exceeded"
    },
    {
      code: 6002,
      name: "InvalidCalculation",
      msg: "Invalid calculation"
    },
    {
      code: 6003,
      name: "MissingPlatformFeeAccount",
      msg: "Missing platform fee account"
    },
    {
      code: 6004,
      name: "InvalidSlippage",
      msg: "Invalid slippage"
    },
    {
      code: 6005,
      name: "NotEnoughPercent",
      msg: "Not enough percent to 100"
    },
    {
      code: 6006,
      name: "InvalidInputIndex",
      msg: "Token input index is invalid"
    },
    {
      code: 6007,
      name: "InvalidOutputIndex",
      msg: "Token output index is invalid"
    },
    {
      code: 6008,
      name: "NotEnoughAccountKeys",
      msg: "Not Enough Account keys"
    },
    {
      code: 6009,
      name: "NonZeroMinimumOutAmountNotSupported",
      msg: "Non zero minimum out amount not supported"
    },
    {
      code: 6010,
      name: "InvalidRoutePlan",
      msg: "Invalid route plan"
    },
    {
      code: 6011,
      name: "InvalidReferralAuthority",
      msg: "Invalid referral authority"
    },
    {
      code: 6012,
      name: "LedgerTokenAccountDoesNotMatch",
      msg: "Token account doesn't match the ledger"
    },
    {
      code: 6013,
      name: "InvalidTokenLedger",
      msg: "Invalid token ledger"
    },
    {
      code: 6014,
      name: "IncorrectTokenProgramID",
      msg: "Token program ID is invalid"
    },
    {
      code: 6015,
      name: "TokenProgramNotProvided",
      msg: "Token program not provided"
    },
    {
      code: 6016,
      name: "SwapNotSupported",
      msg: "Swap not supported"
    },
    {
      code: 6017,
      name: "ExactOutAmountNotMatched",
      msg: "Exact out amount doesn't match"
    },
    {
      code: 6018,
      name: "SourceAndDestinationMintCannotBeTheSame",
      msg: "Source mint and destination mint cannot the same"
    }
  ]
};

// src/constants.ts
var JUPITER_PROGRAM_V4_ID = new PublicKey("JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB");
var JUPITER_PROGRAM_V6_ID = new PublicKey("JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4");
var JUPITER_PROGRAM_ID_DEVNET = new PublicKey("BHzPYvC5J38kUeqkcUXwfraLWJ68cmGWm43ksF3i8bmk");
var JUPITER_PROGRAM_ID_STAGING = new PublicKey("JUPSjgjMFjU4453KMgxhqVmzep6W352bQpE4RsNqXAx");
var MAINNET_SERUM_DEX_PROGRAM = new PublicKey("9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin");
var DEVNET_SERUM_DEX_PROGRAM = new PublicKey("DESVgJVGajEgKGXhb6XmqDHGz3VjdgP7rEVESBgxmroY");
var RAYDIUM_AMM_V4_PROGRAM_ID = new PublicKey("675kPX9MHTjS2zt1qfr1NYHuzeLXfQM9H24wFSUt1Mp8");
var ALDRIN_SWAP_PROGRAM_ID = new PublicKey("AMM55ShdkoGRB5jVYPjWziwk8m5MpwyDgsMWHaMSQWH6");
var ALDRIN_SWAP_V2_PROGRAM_ID = new PublicKey("CURVGoZn8zycx6FXwwevgBTB2gVvdbGTEpvMJDbgs2t4");
var SABER_ADD_DECIMALS_PROGRAM_ID = new PublicKey("DecZY86MU5Gj7kppfUCEmd4LbXXuyZH1yHaP2NTqdiZB");
var CROPPER_PROGRAM_ID = new PublicKey("CTMAxxk34HjKWxQ3QLZK1HpaLXmBveao3ESePXbiyfzh");
var SENCHA_PROGRAM_ID = new PublicKey("SCHAtsf8mbjyjiv4LkhLKutTf6JnZAbdJKFkXQNMFHZ");
var LIFINITY_PROGRAM_ID = new PublicKey("EewxydAPCCVuNEyrVN68PuSYdQ7wKn27V9Gjeoi8dy3S");
var CREMA_PROGRAM_ID = new PublicKey("CLMM9tUoggJu2wagPkkqs9eFG4BWhVBZWkP1qv3Sp7tR");
var CREMA_PARTNER_ACCOUNT = new PublicKey("FxYoB1VAx8TfLCwvmworJy16VH89v992qznUvBX5aR8K");
var MERCURIAL_SWAP_PROGRAM_ID = new PublicKey("MERLuDFBMmsHnsBPZw2sDQZHvXFMwp8EdjudcU2HKky");
var WHIRLPOOL_PROGRAM_ID = new PublicKey("whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc");
var INVARIANT_PROGRAM_ID = new PublicKey("HyaB3W9q6XdA5xwpU4XnSZV94htfmbmqJXZcEbRaJutt");
var INVARIANT_STATE_ID = new PublicKey("8NsPwRFYqob3FzYvHYTjFK6WVFJADFN8Hn7yNQKcVNW1");
var INVARIANT_PROGRAM_AUTHORITY_ID = new PublicKey("J4uBbeoWpZE8fH58PM1Fp9n9K6f1aThyeVCyRdJbaXqt");
var CYKURA_PROGRAM_ID = new PublicKey("cysPXAjehMpVKUapzbMCCnpFxUFFryEWEaLgnb9NrR8");
var CYKURA_FACTORY_STATE_ADDRESS = new PublicKey("DBsMwKfeoUHhxMi9x6wd2AsT12UwUCssjNbUzu1aKgqj");
var MARINADE_PROGRAM_ID = new PublicKey("MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD");
var STEPN_PROGRAM_ID = new PublicKey("Dooar9JkhdZ7J3LHN3A7YCuoGRUggXhQaG4kijfLGU2j");
var ORCA_V1_PROGRAM_ID = new PublicKey("DjVE6JNiYqPL2QXyCUUh8rNjHrbz9hXHNYt99MQ59qw1");
var ORCA_V2_PROGRAM_ID = new PublicKey("9W959DqEETiGZocYWCQPaJ6sBmUzgfxXfqGeTEdp3aQP");
var STEP_TOKEN_SWAP_PROGRAM_ID = new PublicKey("SSwpMgqNDsyV7mAgN9ady4bDVu5ySjmmXejXvy2vLt1");
var PENGUIN_PROGRAM_ID = new PublicKey("PSwapMdSai8tjrEXcxFeQth87xC4rRsa4VA5mhGhXkP");
var SAROS_PROGRAM_ID = new PublicKey("SSwapUtytfBdBn1b9NUGG6foMVPtcWgpRU32HToDUZr");
var METEORA_PROGRAM_ID = new PublicKey("Eo7WjKq67rjJQSZxS6z3YkapzY3eMj6Xy8X5EQVn5UaB");
var METEORA_VAULT_PROGRAM_ID = new PublicKey("24Uqj9JCLxUeoC3hGfh5W3s9FM9uCHDS2SG3LYwBpyTi");
var DELTA_FI_PROGRAM_ID = new PublicKey("GNExJhNUhc9LN2DauuQAUJnXoy6DJ6zey3t9kT9A2PF3");
var DELTA_FI_USER_ID = new PublicKey("ziSPuDShwunW4xNrCfTnSHTPVT6FZDREtdofpf1BJwe");
var GOOSE_FX_PROGRAM_ID = new PublicKey("7WduLbRfYhTJktjLw5FDEyrqoEv61aTTCuGAetgLjzN5");
var GOOSE_FX_CONTROLLER_ID = new PublicKey("8CxKnuJeoeQXFwiG6XiGY2akBjvJA5k3bE52BfnuEmNQ");
var BALANSOL_PROGRAM_ID = new PublicKey("D3BBjqUdCYuP18fNvvMbPAZ8DpcRi4io2EsYHQawJDag");
var DRADEX_PROGRAM_ID = new PublicKey("dp2waEWSBy5yKmq65ergoU3G6qRLmqa6K7We4rZSKph");
var DRADEX_LOGGER_PROGRAM_ID = new PublicKey("1gE3LGQze8DQ3KD2C4ZUCmRX5g4njhY5yLfYmnmcvJR");
var DRADEX_MASTER_ID = new PublicKey("76ygWLcvJLR6nSzRUpiQqqtX4Pabkq4vpaTxwr3mDcXA");
var LIFINITY_V2_PROGRAM_ID = new PublicKey("2wT8Yq49kHgDzXuPxZSaeLaH1qbmGXtEyPy64bL7aD3c");
var DRADEX_DEX_USER = new PublicKey("571oqNkJauZ2tccLwf8CUB56hpLPZkop9X1Px4DE9rnQ");
var RAYDIUM_CLMM_PROGRAM_ID = new PublicKey("CAMMCzo5YL8w4VFF8KVHrK22GGUsp5VTaW7grrKgrWqK");
var OPENBOOK_PROGRAM_ID = new PublicKey("srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX");
var MARCO_POLO_PROGRAM_ID = new PublicKey("9tKE7Mbmj4mxDjWatikzGAtkoWosiiZX9y6J4Hfm2R8H");
var MARCO_POLO_STATE_ID = new PublicKey("BE5YRQ6N6LCw7UL3JwzVp317EWa4mzJY6JKDaudcXu7A");
var MARCO_POLO_PROGRAM_AUTHORITY = new PublicKey("JM78XNzeQRmZXDAP4DSq88ZdErbuSXSLE6fkRsVDKSu");
var BONK_SWAP_PROGRAM_ID = new PublicKey("BSwp6bEBihVLdqJRKGgzjcGLHkcTuzmSo1TQkHepzH8p");
var BONK_SWAP_STATE_ID = new PublicKey("2QWN6WjrJ3RAk51ecxLxaLPfFCYLAnmWJwJ1oKA92CRD");
var BONK_SWAP_PROGRAM_AUTHORITY = new PublicKey("8NyaPDJeC2eaBGpkRpZKnD9S448AZGgjSvumFe92DRK2");
var PHOENIX_PROGRAM_ID = new PublicKey("PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY");
var SYMMETRY_PROGRAM_ID = new PublicKey("2KehYt3KsEQR53jYcxjbQp2d2kCp4AkuQW68atufRwSr");
var WRAPPED_SOL_MINT = new PublicKey("So11111111111111111111111111111111111111112");
var MARKETS_URL = {
  devnet: "https://jupiter-devnet.zhen8558.workers.dev/markets?v=3",
  // 'https://api.jup.ag/api/markets/cache/devnet',
  "mainnet-beta": "https://cache.jup.ag/markets?v=3",
  testnet: "https://api.jup.ag/api/markets/cache/devnet"
};
var INDEXED_ROUTE_MAP_URL = "https://cache.jup.ag/indexed-route-maps-v3";
var TOKEN_LIST_URL = {
  devnet: "https://api.jup.ag/api/tokens/devnet",
  testnet: "https://api.jup.ag/api/markets/devnet",
  "mainnet-beta": "https://cache.jup.ag/tokens",
  localnet: "https://cache.jup.ag/tokens"
};
var LAMPORTS_PER_SIGNATURE = 5e3;
var JUPITER_FEE_OWNER = new PublicKey("BUX7s2ef2htTGb2KKoPHWkmzxPj4nTWMWRgs5CSbQxf9");
var JUPITER_COMMON_ERRORS = {
  AlreadyInUse: {
    code: 0,
    name: "AlreadyInUsed",
    msg: "Account already In Used"
  },
  InsufficientSOL: {
    code: 1,
    name: "InsufficientSOL",
    msg: "Insufficient SOL"
  },
  TransactionNotConfirmed: {
    code: 7e3,
    // a code that is not in the list of errors
    name: "TransactionNotConfirmed",
    msg: "Transaction was not confirmed"
  },
  BalancesNotExtractedProperly: {
    code: 7001,
    // a code that is not in the list of errors
    name: "BalancesNotExtractedProperly",
    msg: "Balances cannot be extracted properly"
  },
  TooManyAccountLocked: {
    code: 7002,
    name: "TooManyAccountsLocked",
    msg: "Transaction not proccessed due to too many accounts locked"
  },
  FrozenAccount: {
    code: 17,
    name: "FrozenAccount",
    msg: "The token account is frozen"
  }
};
var JUPITER_V6_ERRORS = Object.freeze({
  ...JUPITER_COMMON_ERRORS,
  ...IDL_V6.errors.reduce((accErrors, error) => {
    return { ...accErrors, [error.name]: error };
  }, {})
});

// src/utils/getEvents.ts
import { utils } from "@coral-xyz/anchor";

// src/program.ts
import { Program } from "@coral-xyz/anchor";
var JUPITER_PROGRAM = new Program(IDL_V6, JUPITER_PROGRAM_V6_ID, {});

// src/utils/getEvents.ts
function getEvents(transactionResponse) {
  var _a;
  let events = [];
  if (transactionResponse && transactionResponse.meta) {
    let { meta } = transactionResponse;
    (_a = meta.innerInstructions) == null ? void 0 : _a.map(async (ix) => {
      ix.instructions.map(async (iix) => {
        const ixData = utils.bytes.bs58.decode(iix.data);
        const eventData = utils.bytes.base64.encode(ixData.subarray(8));
        const event = JUPITER_PROGRAM.coder.events.decode(eventData);
        if (!event) return;
        events.push(event);
      });
    });
  }
  return events;
}

// src/utils/transactionHelpers.ts
import { BN } from "@coral-xyz/anchor";
function getKeyMap(message, accountKeysFromLookups) {
  return message.getAccountKeys({ accountKeysFromLookups }).keySegments().flat().reduce((acc, key, index) => {
    acc.set(key.toBase58(), index);
    return acc;
  }, /* @__PURE__ */ new Map());
}
function diffTokenBalance(meta, owner, mint) {
  var _a, _b, _c, _d;
  const postBalance = (_b = (_a = meta.postTokenBalances) == null ? void 0 : _a.find(
    (postTokenBalance) => postTokenBalance.owner === owner && postTokenBalance.mint === mint
  )) == null ? void 0 : _b.uiTokenAmount.amount;
  const preBalance = (_d = (_c = meta.preTokenBalances) == null ? void 0 : _c.find(
    (preTokenBalance) => preTokenBalance.owner === owner && preTokenBalance.mint === mint
  )) == null ? void 0 : _d.uiTokenAmount.amount;
  if (!postBalance) return;
  return Math.abs(parseInt(postBalance) - (preBalance !== void 0 ? parseInt(preBalance) : 0));
}
function extractTokenBalanceChangeFromTransaction(meta, user, mint) {
  if (!meta) return;
  return diffTokenBalance(meta, user.toBase58(), mint.toBase58());
}
function extractSOLChangeFromTransaction(meta, keyMap, user) {
  const accountKeyIndex = keyMap.get(user.toBase58());
  if (accountKeyIndex !== void 0) {
    return Math.abs(meta.postBalances[accountKeyIndex] - meta.preBalances[accountKeyIndex]);
  }
  return 0;
}
function extractTokenBalanceChangesFromEvents(events, inputMint, outputMint) {
  let inputAmount = new BN(0);
  let outputAmount = new BN(0);
  events.forEach((event) => {
    if (event.data.inputMint.equals(inputMint)) {
      inputAmount = inputAmount.add(event.data.inputAmount);
    }
    if (event.data.outputMint.equals(outputMint)) {
      outputAmount = outputAmount.add(event.data.outputAmount);
    }
  });
  return [Number(inputAmount.toString()), Number(outputAmount.toString())];
}
function getTokenBalanceChangesFromTransactionResponse({
  txid,
  user,
  inputMint,
  outputMint,
  transactionResponse,
  hasWrappedSOL
}) {
  let sourceTokenBalanceChange;
  let destinationTokenBalanceChange;
  let events = [];
  let swapEvents = [];
  if (transactionResponse && transactionResponse.meta) {
    let { meta, transaction } = transactionResponse;
    events = getEvents(transactionResponse);
    swapEvents = events.filter((event) => event.name === "SwapEvent");
    [sourceTokenBalanceChange, destinationTokenBalanceChange] = extractTokenBalanceChangesFromEvents(
      swapEvents,
      inputMint,
      outputMint
    );
    if (!sourceTokenBalanceChange || !destinationTokenBalanceChange) {
      const keyMap = getKeyMap(transaction.message, meta.loadedAddresses);
      sourceTokenBalanceChange = inputMint.equals(WRAPPED_SOL_MINT) && !hasWrappedSOL ? extractSOLChangeFromTransaction(meta, keyMap, user) : extractTokenBalanceChangeFromTransaction(meta, user, inputMint);
      destinationTokenBalanceChange = outputMint.equals(WRAPPED_SOL_MINT) && !hasWrappedSOL ? extractSOLChangeFromTransaction(meta, keyMap, user) : extractTokenBalanceChangeFromTransaction(meta, user, outputMint);
    }
  }
  if (!(sourceTokenBalanceChange && destinationTokenBalanceChange)) {
    throw new TransactionError(
      "Cannot find source or destination token account balance change",
      txid,
      JUPITER_COMMON_ERRORS["BalancesNotExtractedProperly"].code,
      [JUPITER_PROGRAM_V6_ID.toBase58()]
    );
  }
  return [sourceTokenBalanceChange, destinationTokenBalanceChange];
}
function getUnixTs() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function getSignature(transaction) {
  const signature = "signature" in transaction ? transaction.signature : transaction.signatures[0];
  if (!signature) {
    throw new Error("Missing transaction signature, the transaction was not signed by the fee payer");
  }
  return bs58.encode(signature);
}
function getTransactionBlockhash(transaction) {
  if ("version" in transaction) {
    return transaction.message.recentBlockhash;
  } else {
    if (!transaction.recentBlockhash) throw new Error("Missing blockhash");
    return transaction.recentBlockhash;
  }
}
function signTransaction(transaction, signers) {
  if ("version" in transaction) {
    transaction.sign(signers);
  } else {
    transaction.sign(...signers);
  }
  return getSignature(transaction);
}

// src/utils/executeTransaction.ts
function transformIntoJsTransaction(swapTransaction) {
  if ("version" in swapTransaction) {
    return swapTransaction;
  } else {
    return new Transaction({
      feePayer: swapTransaction.feePayer,
      recentBlockhash: swapTransaction.recentBlockhash
    }).add(...swapTransaction.instructions);
  }
}
var executeTransaction = async ({
  connection,
  wallet,
  onTransaction,
  inputMint,
  outputMint,
  sourceAddress,
  destinationAddress,
  swapTransaction,
  blockhashWithExpiryBlockHeight,
  owner,
  wrapUnwrapSOL,
  minContextSlot
}) => {
  let swapError = void 0;
  let swapResult = void 0;
  try {
    if (owner.signer) {
      signTransaction(swapTransaction, [owner.signer]);
    } else {
      if (!wallet) throw new Error("Signer wallet not found");
      swapTransaction = transformIntoJsTransaction(swapTransaction);
      swapTransaction = await wallet.signTransaction(swapTransaction);
    }
    const swapTxid = getSignature(swapTransaction);
    const skipPreflight = true;
    try {
      const swapTransactionSender = async () => {
        try {
          const transactionResponse2 = await handleSendTransaction({
            ...blockhashWithExpiryBlockHeight,
            connection,
            signedTransaction: swapTransaction,
            idl: IDL_V6,
            idlProgramId: JUPITER_PROGRAM_V6_ID,
            skipPreflight,
            minContextSlot
          });
          if ("error" in transactionResponse2) {
            return mapCommonErrorToJupiterError(transactionResponse2.error);
          }
          return transactionResponse2.transactionResponse;
        } catch (e) {
          return e;
        }
      };
      const swapPromise = swapTransactionSender();
      onTransaction == null ? void 0 : onTransaction(swapTxid, swapPromise);
      const transactionResponse = await swapPromise;
      if (transactionResponse instanceof Error) {
        throw transactionResponse;
      }
      const [sourceTokenBalanceChange, destinationTokenBalanceChange] = getTokenBalanceChangesFromTransactionResponse({
        txid: swapTxid,
        inputMint,
        outputMint,
        user: owner.publicKey,
        transactionResponse,
        hasWrappedSOL: !wrapUnwrapSOL
      });
      swapResult = {
        txid: swapTxid,
        inputAddress: sourceAddress,
        outputAddress: destinationAddress,
        inputAmount: sourceTokenBalanceChange,
        outputAmount: destinationTokenBalanceChange
      };
    } catch (e) {
      console.error(e);
      swapError = e;
    }
    if (swapError || !swapResult) {
      throw swapError || new Error("Swap failed");
    }
    return swapResult;
  } catch (error) {
    return { error };
  }
};
var mapCommonErrorToJupiterError = (error) => {
  switch (error.message) {
    case COMMON_TX_ERRORS.TRANSACTION_NOT_CONFIRMED: {
      const errorDetails = JUPITER_COMMON_ERRORS["TransactionNotConfirmed"];
      return new TransactionError2(errorDetails.msg, void 0, errorDetails.code, [JUPITER_PROGRAM_V6_ID.toBase58()]);
    }
    case COMMON_TX_ERRORS.TOO_MANY_ACCOUNT_LOCKS: {
      const errorDetails = JUPITER_COMMON_ERRORS["TooManyAccountLocked"];
      return new TransactionError2(errorDetails.msg, void 0, errorDetails.code, [JUPITER_PROGRAM_V6_ID.toBase58()]);
    }
    case COMMON_TX_ERRORS.FROZEN_ACCOUNT: {
      const errorDetails = JUPITER_COMMON_ERRORS["FrozenAccount"];
      return new TransactionError2(errorDetails.msg, void 0, errorDetails.code, error.programIds);
    }
    default: {
      return error;
    }
  }
};

// src/utils/Owner.ts
var Owner = class _Owner {
  _owner;
  constructor(owner) {
    this._owner = owner;
  }
  get publicKey() {
    if (_Owner.isKeyPair(this._owner)) {
      return this._owner.publicKey;
    }
    return this._owner;
  }
  get signer() {
    return _Owner.isKeyPair(this._owner) ? this._owner : void 0;
  }
  get isKeyPair() {
    return _Owner.isKeyPair(this._owner);
  }
  get isPublicKey() {
    return _Owner.isPublicKey(this._owner);
  }
  static isKeyPair(owner) {
    return owner.secretKey !== void 0;
  }
  static isPublicKey(owner) {
    return !_Owner.isKeyPair(owner);
  }
};

// src/utils/wait.ts
var wait = (time) => new Promise((resolve) => setTimeout(resolve, time));

// src/utils/indexedRouteMap.ts
function getOrAddKeyToIndexMap(pk, mintToIndexMap) {
  let keyIndex = mintToIndexMap.get(pk);
  if (keyIndex === void 0) {
    keyIndex = mintToIndexMap.size;
    mintToIndexMap.set(pk, keyIndex);
  }
  return keyIndex;
}
function routeMapToIndexedRouteMap(routeMap) {
  const { mintToIndexMap, indexedRouteMap: innerIndexedRouteMap } = Array.from(routeMap).reduce(
    ({ mintToIndexMap: mintToIndexMap2, indexedRouteMap: indexedRouteMap2 }, [key, item]) => {
      const keyIndex = getOrAddKeyToIndexMap(key, mintToIndexMap2);
      const indexedOutputMintCache = [];
      for (const routeOutputKey of item) {
        const routeOutputKeyIndex = getOrAddKeyToIndexMap(routeOutputKey, mintToIndexMap2);
        indexedOutputMintCache.push(routeOutputKeyIndex);
      }
      indexedRouteMap2[keyIndex] = indexedOutputMintCache;
      return { mintToIndexMap: mintToIndexMap2, indexedRouteMap: indexedRouteMap2 };
    },
    { mintToIndexMap: /* @__PURE__ */ new Map(), indexedRouteMap: {} }
  );
  const indexedRouteMap = {
    mintKeys: Array.from(mintToIndexMap.keys()),
    indexedRouteMap: innerIndexedRouteMap
  };
  return indexedRouteMap;
}
function indexedRouteMapToRouteMap(indexedRouteMap) {
  const getMint = (index) => indexedRouteMap.mintKeys[index];
  const generatedRouteMap = /* @__PURE__ */ new Map();
  Object.keys(indexedRouteMap.indexedRouteMap).forEach((key) => {
    generatedRouteMap.set(
      getMint(key),
      indexedRouteMap["indexedRouteMap"][key].map((index) => getMint(index))
    );
  });
  return generatedRouteMap;
}
async function getRemoteRouteMap({ onlyDirectRoutes, asLegacyTransaction }, indexedRouteMapUrl) {
  let url = indexedRouteMapUrl || INDEXED_ROUTE_MAP_URL;
  if (onlyDirectRoutes) {
    url = url.concat("?onlyDirectRoutes=true");
  } else if (asLegacyTransaction) {
    url = url.concat("?asLegacyTransaction=true");
  }
  const indexedRouteMap = await (await fetch(url)).json();
  return indexedRouteMapToRouteMap(indexedRouteMap);
}

// src/utils/TransactionBuilder.ts
import {
  sendAndConfirmRawTransaction,
  TransactionMessage,
  VersionedTransaction as VersionedTransaction2,
  Transaction as Transaction2
} from "@solana/web3.js";
var TransactionBuilder = class {
  connection;
  feePayer;
  instructions;
  owner;
  constructor(connection, feePayer, owner) {
    this.connection = connection;
    this.feePayer = feePayer;
    this.instructions = [];
    this.owner = owner;
  }
  addInstruction(instruction) {
    this.instructions.push(instruction);
    return this;
  }
  async build(blockhashWithExpiryBlockHeight, addressLookupTables, asLegacyTransaction) {
    let instructions = [];
    let setupInstructions = [];
    let cleanupInstructions = [];
    let signers = [];
    this.instructions.forEach((curr) => {
      setupInstructions = setupInstructions.concat(curr.setupInstructions);
      instructions = instructions.concat(curr.instructions);
      cleanupInstructions = cleanupInstructions.concat(curr.cleanupInstructions);
      signers = signers.concat(curr.signers);
    });
    const transactionInstructions = setupInstructions.concat(instructions).concat(cleanupInstructions);
    const transaction = asLegacyTransaction ? this.buildLegacyTransaction({ transactionInstructions, blockhashWithExpiryBlockHeight }) : this.buildVersionedTransaction({
      transactionInstructions,
      blockhashWithExpiryBlockHeight,
      addressLookupTables
    });
    return {
      transaction,
      signers,
      execute: this.owner.isKeyPair ? () => {
        const signature = signTransaction(transaction, [this.owner.signer, ...signers]);
        const serializedTx = transaction.serialize();
        return sendAndConfirmRawTransaction(this.connection, Buffer.from(serializedTx), {
          signature,
          ...blockhashWithExpiryBlockHeight
        });
      } : async () => {
        throw new Error("Please use a Keypair for the owner parameter to enable the execute function");
      }
    };
  }
  buildLegacyTransaction({
    transactionInstructions,
    blockhashWithExpiryBlockHeight
  }) {
    return new Transaction2({ feePayer: this.feePayer, ...blockhashWithExpiryBlockHeight }).add(
      ...transactionInstructions
    );
  }
  buildVersionedTransaction({
    transactionInstructions,
    blockhashWithExpiryBlockHeight,
    addressLookupTables
  }) {
    const transactionMessage = new TransactionMessage({
      payerKey: this.feePayer,
      instructions: transactionInstructions,
      recentBlockhash: blockhashWithExpiryBlockHeight.blockhash
    });
    const messageV0 = transactionMessage.compileToV0Message(addressLookupTables);
    return new VersionedTransaction2(messageV0);
  }
};

// src/utils/instruction.ts
var getEmptyInstruction = () => ({
  setupInstructions: [],
  instructions: [],
  cleanupInstructions: [],
  signers: []
});

// src/utils/token.ts
import { deserializeAccount } from "@mercurial-finance/optimist";
import { ASSOCIATED_TOKEN_PROGRAM_ID, Token, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { PublicKey as PublicKey4, SystemProgram, TransactionInstruction as TransactionInstruction2 } from "@solana/web3.js";
import JSBI from "jsbi";
async function createAndCloseWSOLAccount({
  connection,
  amount,
  owner: { publicKey }
}) {
  const result = getEmptyInstruction();
  const toAccount = findAssociatedTokenAddress({
    walletAddress: publicKey,
    tokenMintAddress: WRAPPED_SOL_MINT
  });
  const info = await connection.getAccountInfo(toAccount);
  if (info === null) {
    result.setupInstructions.push(
      createAssociatedTokenAccountIdempotentInstruction(publicKey, toAccount, publicKey, WRAPPED_SOL_MINT)
    );
  }
  result.setupInstructions.push(
    SystemProgram.transfer({
      fromPubkey: publicKey,
      toPubkey: toAccount,
      lamports: JSBI.toNumber(amount)
    })
  );
  result.setupInstructions.push(
    // This is not exposed by the types, but indeed it exists
    Token.createSyncNativeInstruction(TOKEN_PROGRAM_ID, toAccount)
  );
  result.cleanupInstructions = [
    Token.createCloseAccountInstruction(TOKEN_PROGRAM_ID, toAccount, publicKey, publicKey, [])
  ];
  return {
    address: toAccount,
    ...result
  };
}
async function findOrCreateAssociatedAccountByMint({
  connection,
  payer,
  owner: { publicKey },
  mintAddress,
  unwrapSOL
}) {
  const mint = typeof mintAddress === "string" ? new PublicKey4(mintAddress) : mintAddress;
  const toAccount = findAssociatedTokenAddress({
    tokenMintAddress: mint,
    walletAddress: publicKey
  });
  const result = getEmptyInstruction();
  const info = await connection.getAccountInfo(toAccount);
  if (info === null) {
    result.setupInstructions.push(createAssociatedTokenAccountIdempotentInstruction(payer, toAccount, publicKey, mint));
  } else {
    const tokenAccountInfo = deserializeAccount(info.data);
    if (tokenAccountInfo && !tokenAccountInfo.owner.equals(publicKey)) {
      throw new Error(`/! ATA ${toAccount.toBase58()} is not owned by ${publicKey.toBase58()}`);
    }
  }
  if (mint.equals(WRAPPED_SOL_MINT) && unwrapSOL) {
    result.cleanupInstructions.push(
      Token.createCloseAccountInstruction(TOKEN_PROGRAM_ID, toAccount, publicKey, publicKey, [])
    );
  }
  return {
    address: toAccount,
    ...result
  };
}
function createAssociatedTokenAccountIdempotentInstruction(payer, associatedToken, owner, mint, programId = TOKEN_PROGRAM_ID, associatedTokenProgramId = ASSOCIATED_TOKEN_PROGRAM_ID) {
  const keys = [
    { pubkey: payer, isSigner: true, isWritable: true },
    { pubkey: associatedToken, isSigner: false, isWritable: true },
    { pubkey: owner, isSigner: false, isWritable: false },
    { pubkey: mint, isSigner: false, isWritable: false },
    { pubkey: SystemProgram.programId, isSigner: false, isWritable: false },
    { pubkey: programId, isSigner: false, isWritable: false }
  ];
  return new TransactionInstruction2({
    keys,
    programId: associatedTokenProgramId,
    data: Buffer.from([1])
  });
}
var findAssociatedTokenAddress = ({
  walletAddress,
  tokenMintAddress
}) => {
  return PublicKey4.findProgramAddressSync(
    [walletAddress.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), tokenMintAddress.toBuffer()],
    ASSOCIATED_TOKEN_PROGRAM_ID
  )[0];
};

// src/types.ts
var SwapMode = /* @__PURE__ */ ((SwapMode2) => {
  SwapMode2["ExactIn"] = "ExactIn";
  SwapMode2["ExactOut"] = "ExactOut";
  return SwapMode2;
})(SwapMode || {});

// src/fee.ts
import { PublicKey as PublicKey5 } from "@solana/web3.js";
import { deserializeAccount as deserializeAccount2 } from "@mercurial-finance/optimist";
var SERUM_OPEN_ACCOUNT_LAMPORTS = 23352760;
var OPEN_TOKEN_ACCOUNT_LAMPORTS = 2039280;
var WALLET_RENT_EXEMPT_MINIMUM = 890880;
var LAMPORTS_PER_SIGNATURE2 = 5e3;
function sum(values) {
  return values.reduce((value, acc) => {
    acc += value;
    return acc;
  }, 0);
}
var calculateTransactionDepositAndFee = ({
  intermediates,
  destination,
  openOrders,
  hasWrapUnwrapSOL,
  feeCalculator
}) => {
  const openOrdersDeposits = openOrders.filter((ooi) => ooi && ooi.setupInstructions.length > 0).map(() => SERUM_OPEN_ACCOUNT_LAMPORTS);
  const ataDeposits = [...intermediates, destination].filter((item) => (item == null ? void 0 : item.setupInstructions.length) && item.cleanupInstructions.length === 0).map(() => OPEN_TOKEN_ACCOUNT_LAMPORTS);
  const signatureFee = feeCalculator.lamportsPerSignature;
  const totalFeeAndDeposits = sum([signatureFee, ...openOrdersDeposits, ...ataDeposits]);
  const minimumSOLForTransaction = sum([
    signatureFee,
    ...openOrdersDeposits,
    ...ataDeposits,
    WALLET_RENT_EXEMPT_MINIMUM,
    hasWrapUnwrapSOL ? OPEN_TOKEN_ACCOUNT_LAMPORTS : 0
  ]);
  return {
    signatureFee,
    openOrdersDeposits,
    ataDeposits,
    totalFeeAndDeposits,
    minimumSOLForTransaction
  };
};
var calculateTransactionDepositAndFeeV2 = ({
  numOfAtasToBeCreated,
  numOfOpenOrdersToBeCreated,
  isInputMintSOL
}) => {
  const openOrdersDeposits = new Array(numOfOpenOrdersToBeCreated).fill(0).map(() => SERUM_OPEN_ACCOUNT_LAMPORTS);
  const ataDeposits = new Array(numOfAtasToBeCreated).fill(0).map(() => OPEN_TOKEN_ACCOUNT_LAMPORTS);
  const signatureFee = LAMPORTS_PER_SIGNATURE2;
  const totalFeeAndDeposits = sum([signatureFee, ...openOrdersDeposits, ...ataDeposits]);
  const minimumSOLForTransaction = sum([
    signatureFee,
    ...openOrdersDeposits,
    ...ataDeposits,
    isInputMintSOL ? WALLET_RENT_EXEMPT_MINIMUM : 0
  ]);
  return {
    signatureFee,
    openOrdersDeposits,
    ataDeposits,
    totalFeeAndDeposits,
    minimumSOLForTransaction
  };
};
var REFERRAL_PROGRAM_ID = new PublicKey5("REFER4ZgmyYx9c6He5XfaTMiGfdLwRnkV4RPp9t9iF3");
var REFERRAL_ATA_SEED = Buffer.from("referral_ata");
var getReferralTokenAccount = async ({ connection, referralAccount, mint }) => {
  const referralTokenAccountAddress = PublicKey5.findProgramAddressSync(
    [REFERRAL_ATA_SEED, referralAccount.toBuffer(), mint.toBuffer()],
    REFERRAL_PROGRAM_ID
  )[0];
  const accountInfo = await connection.getAccountInfo(referralTokenAccountAddress);
  if (!accountInfo) return null;
  const tokenAccount = deserializeAccount2(accountInfo.data);
  if (!tokenAccount) return null;
  if (tokenAccount.isFrozen) return null;
  return referralTokenAccountAddress;
};
export {
  ALDRIN_SWAP_PROGRAM_ID,
  ALDRIN_SWAP_V2_PROGRAM_ID,
  BALANSOL_PROGRAM_ID,
  BONK_SWAP_PROGRAM_AUTHORITY,
  BONK_SWAP_PROGRAM_ID,
  BONK_SWAP_STATE_ID,
  CREMA_PARTNER_ACCOUNT,
  CREMA_PROGRAM_ID,
  CROPPER_PROGRAM_ID,
  CYKURA_FACTORY_STATE_ADDRESS,
  CYKURA_PROGRAM_ID,
  DELTA_FI_PROGRAM_ID,
  DELTA_FI_USER_ID,
  DEVNET_SERUM_DEX_PROGRAM,
  DRADEX_DEX_USER,
  DRADEX_LOGGER_PROGRAM_ID,
  DRADEX_MASTER_ID,
  DRADEX_PROGRAM_ID,
  GOOSE_FX_CONTROLLER_ID,
  GOOSE_FX_PROGRAM_ID,
  IDL_V6,
  INDEXED_ROUTE_MAP_URL,
  INVARIANT_PROGRAM_AUTHORITY_ID,
  INVARIANT_PROGRAM_ID,
  INVARIANT_STATE_ID,
  JUPITER_COMMON_ERRORS,
  JUPITER_FEE_OWNER,
  JUPITER_PROGRAM_ID_DEVNET,
  JUPITER_PROGRAM_ID_STAGING,
  JUPITER_PROGRAM_V4_ID,
  JUPITER_PROGRAM_V6_ID,
  JUPITER_V6_ERRORS,
  LAMPORTS_PER_SIGNATURE,
  LIFINITY_PROGRAM_ID,
  LIFINITY_V2_PROGRAM_ID,
  MAINNET_SERUM_DEX_PROGRAM,
  MARCO_POLO_PROGRAM_AUTHORITY,
  MARCO_POLO_PROGRAM_ID,
  MARCO_POLO_STATE_ID,
  MARINADE_PROGRAM_ID,
  MARKETS_URL,
  MERCURIAL_SWAP_PROGRAM_ID,
  METEORA_PROGRAM_ID,
  METEORA_VAULT_PROGRAM_ID,
  OPENBOOK_PROGRAM_ID,
  ORCA_V1_PROGRAM_ID,
  ORCA_V2_PROGRAM_ID,
  Owner,
  PENGUIN_PROGRAM_ID,
  PHOENIX_PROGRAM_ID,
  RAYDIUM_AMM_V4_PROGRAM_ID,
  RAYDIUM_CLMM_PROGRAM_ID,
  SABER_ADD_DECIMALS_PROGRAM_ID,
  SAROS_PROGRAM_ID,
  SENCHA_PROGRAM_ID,
  STEPN_PROGRAM_ID,
  STEP_TOKEN_SWAP_PROGRAM_ID,
  SYMMETRY_PROGRAM_ID,
  SwapMode,
  TOKEN_LIST_URL,
  TransactionBuilder,
  WHIRLPOOL_PROGRAM_ID,
  WRAPPED_SOL_MINT,
  calculateTransactionDepositAndFee,
  calculateTransactionDepositAndFeeV2,
  createAndCloseWSOLAccount,
  createAssociatedTokenAccountIdempotentInstruction,
  executeTransaction,
  extractSOLChangeFromTransaction,
  extractTokenBalanceChangeFromTransaction,
  extractTokenBalanceChangesFromEvents,
  findAssociatedTokenAddress,
  findOrCreateAssociatedAccountByMint,
  getEmptyInstruction,
  getEvents,
  getReferralTokenAccount,
  getRemoteRouteMap,
  getSignature,
  getTokenBalanceChangesFromTransactionResponse,
  getTransactionBlockhash,
  getUnixTs,
  indexedRouteMapToRouteMap,
  mapCommonErrorToJupiterError,
  routeMapToIndexedRouteMap,
  signTransaction,
  wait
};
//# sourceMappingURL=index.mjs.map